import * as React from "react";
import {Icon, icons, Tooltip} from "@vebox/etui-core";
import {VeboxExpandable} from "../../../components/expadable/VeboxExpandable";
import {Display} from "../../../components/Display";
import "./styles.scss";
import {RegisterDescriptionTooltip} from "./RegisterDescriptionTooltip";

interface RegisterInfoProps {
    message: string | null;
    isVisible: boolean;
}

export const RegisterInfo: React.FC<RegisterInfoProps> = ({isVisible, message, children}) => {
    const [expanded, setExpanded] = React.useState<boolean>(false);
    const show = () => setExpanded(true);
    const hide = () => setExpanded(false);

    const collapsed = (expanded, setExpanded) => {
        return (
            <div
                className={"font-weight-400 flx-row flx-align-center vertical-align-middle-svg"}
                onMouseOver={show}
                onMouseOut={hide}
            >
                <Icon glyph={icons.INFO_CIRCLE} size={20}/>
            </div>
        );
    }
    return (
        <div className={"container-tooltip"}>
            <Display isVisible={isVisible}>
                <VeboxExpandable
                    key={message}
                    collapsed={collapsed}
                    expanded={expanded}
                >
                    <RegisterDescriptionTooltip message={message}/>
                </VeboxExpandable>
            </Display>
            <div className={"label"}>
                {children}
            </div>
        </div>
    );
}


